<template>
  <router-view></router-view>
</template>

<script>
  export default {
    mounted () {
      this.loadImovel()
    },
    beforeRouteUpdate (to, from, next) {
      this.loadImovel()
      next()
    },
    methods: {
      loadImovel () {
        this.$store.dispatch('imoveis/loadImovel', { id: this.$route.params.id })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ImoveisDetalhes.vue?0b86b712